module.exports = __webpack_public_path__ + "media/images/flags/64/Haiti-08e5e33a5c24cb4f673074406b16ac6e.png";